import { ApiKy } from './index'
import { DownloadCsvSearchParams } from '~/types/invoices'

const { stripEmptyKeys } = useHelpers()

export default class Api extends ApiKy {
  downloadPdfs(invoiceIds: string[]) {
    return this.ky.post(`${this.url}/download-pdfs`, {
      json: { invoiceIds },
    })
  }

  updatePo(invoiceId: string, productOrderNumber: string) {
    return this.ky.post(`${this.url}/${invoiceId}/update-po`, {
      json: { productOrderNumber },
    })
  }

  downloadCsv(searchParams: DownloadCsvSearchParams) {
    const params = stripEmptyKeys(searchParams)
    return this.ky.get(`${this.url}/download-csv`, {
      searchParams: params,
    })
  }
}
